
export const asSentSupport = {
    data: `<svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.02 12.06L22.04 18.5L7 16.5L7.02 12.06ZM22.02 29.5L7 35.94V31.5L22.02 29.5ZM3.02 6L3 20L33 24L3 28L3.02 42L45 24L3.02 6Z"/>
    </svg>
    `,
    name: 'sentSupport',
  };
  